export enum Mid {
    CV = 'cv',
    MDC = 'mdc',
    VDC = 'vdc',
    BCN = 'bcn',
    CMG = 'cmg',
    USA_DV = 'usa_dv',
    BCN_MDC = 'bcn_mdc',
    ACX = 'acx',
    AUMG = 'aumg'
}